import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../pages/homePage'
/**
 *  pc route 路由
 * @returns
 */

interface Iprops {
  weId?: string
}

const pcMain: React.FC<Iprops> = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/home" element={<Home />}></Route>
      </Routes>
    </>
  )
}

const PcMainWrapper: React.FC<Iprops> = () => {
  return (
    <>
      <Home />
    </>
  )
}

export default PcMainWrapper
